/*
 * @Author: huangshimin@klcxkj.com
 * @Date: 2022-03-28 16:41:39
 * @LastEditors: klcxkjhsm huangshimin@klcxkj.com
 * @LastEditTime: 2024-04-01 10:35:49
 * @FilePath: \client-h5\src\pages\waterUseRecord\services.js
 */
import http from '../../utils/http';

export function getBilldetail(params) {
  return http("get", '/order/manage/consume/detail/query',params,false,true);
}
